import { ControlledTable } from "Components";
import FilterData from "Components/Filter2/Data";
import { Filter2DataProps } from "DataTypes/Common";
import { PreApprovedPlanListType } from "DataTypes/PatientManagement.type";
import { actionArrType, columnType } from "DataTypes/Table";

export const TableCol: () => columnType[] = () => {
  const Arr: columnType[] = [
    ControlledTable.ColumnData.ProblemNameCol("20%"),
    ControlledTable.ColumnData.VersionCol("15%"),
    ControlledTable.ColumnData.CreatedByCol("20%"),
    ControlledTable.ColumnData.CreatedAtCol("20%"),
    ControlledTable.ColumnData.StatusCol("20%"),
    ControlledTable.ColumnData.ActionCol(),
  ];
  return Arr;
};

export const actionArr: (
  handleView: () => void,
  handleEnableDisable: () => void,
  data: PreApprovedPlanListType,
  loginUserRoleId: number | null
) => actionArrType[] = (
  handleView,
  handleEnableDisable,
  data,
  loginUserRoleId
) => {
  const Arr: actionArrType[] = [
    ControlledTable.ActionData.ViewCarePlanAction(
      handleView,
      "View Pre-Approved Plan"
    ),
    ...data.status == "DRAFT" ? [] : [
      ControlledTable.ActionData.enableDisableAction(
        handleEnableDisable,
        !data.isDisabled,
        (data.isDisabled &&
            data.disabledByRoleId &&
            loginUserRoleId &&
            loginUserRoleId > data.disabledByRoleId) ? true : false
      ),
    ],
  ];
  return Arr;
};

export const FilterArr: () => Filter2DataProps[] = () => {
  const Arr: Filter2DataProps[] = [
    FilterData.problemName,
    FilterData.papVersion,
    FilterData.createdBy,
    FilterData.createdByDesig,
    FilterData.createdAtFrom,
    FilterData.createdAtTo,
    FilterData.status,
  ];
  return Arr;
};
